module.exports = __webpack_public_path__ + "static/media/Quicksand-Light.704af55f.eot";